import { useCallback, useContext } from 'react'
import confirmationDialogContext from '../../contexts/confirmation-dialog'

const useConfirmationDialog = ({
    onConfirm = () => {},
    onCancel = () => {},
    confirmLabel,
    cancelLabel,
    title,
    description,
} = {}) => {
    const {
        showConfirmation: showDialog
    } = useContext(confirmationDialogContext)

    const showConfirmation = useCallback((overrides = {}) => {
        showDialog({
            title: title || overrides.title,
            confirmLabel: confirmLabel || overrides.confirmLabel,
            cancelLabel: cancelLabel || overrides.cancelLabel,
            description: description || overrides.description,
            onConfirm: onConfirm || overrides.onConfirm,
            onCancel: onCancel || overrides.onCancel,
        })
    }, [showDialog, title, description, confirmLabel, cancelLabel, onConfirm, onCancel])

    return {
        showConfirmation
    }
}

export default useConfirmationDialog
